import { FormattedMessage } from 'react-intl';

import { Schema } from 'src/utils/form';

export default Schema.object({
  contrato: Schema.string().label(<FormattedMessage id="contrato" />),
  convenio: Schema.string().label(<FormattedMessage id="convenio" />),
  dataInicio: Schema.string().label(<FormattedMessage id="dataInicio" />),
  dataTermino: Schema.string().label(<FormattedMessage id="dataTermino" />),
  planoContas: Schema.string().label(''),
  tipoFiltroData: Schema.string().label(''),
  projeto: Schema.string().label(''),
});
